import { render, staticRenderFns } from "./EasyPayAllServicePage.vue?vue&type=template&id=50562284&scoped=true&"
import script from "./EasyPayAllServicePage.vue?vue&type=script&lang=js&"
export * from "./EasyPayAllServicePage.vue?vue&type=script&lang=js&"
import style0 from "./EasyPayAllServicePage.vue?vue&type=style&index=0&id=50562284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50562284",
  null
  
)

export default component.exports